import PropTypes from 'prop-types'
import {HeaderTitle} from '../../../../common/HeaderTitle.jsx'
import {SimpleTable} from "../../../../common/simpleTable/SimpleTable.jsx";
import {tableListaProfili} from "../../lib/columns/tableListaProfili.jsx";
import {useProfile} from "../../../../../api/domain/profile/queries/useProfile.jsx";
import {LinkContainer} from "react-router-bootstrap";
import ButtonWithIcon from "../../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../../common/Icons.jsx";
import {useSelector} from "react-redux";
import {useState} from "react";
import {ModalUsunProfil} from "../../lib/modals.jsx";

const ViewListaProfili = () => {
    const listaPozycji = useProfile()
    const titleName = 'Lista profili'
    const [modalState, setModalState] = useState({
        delete: false,
        edit: false,
        historia: false,
    })
    const rola = useSelector((state) => state.user.role)
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyProfile = Array.isArray(permissions) && permissions.includes('profile_modyfikacja')
    const canViewUsers = Array.isArray(permissions) && permissions.includes('uzytkownicy_podglad')
    const [currPozycja, setCurrPozycja] = useState({})
    const openModal = (type, data) => {
        setCurrPozycja(data)
        setModalState((prev) => ({...prev, [type]: true}))
    }

    const closeModal = (type) =>
        setModalState((prev) => ({...prev, [type]: false}))


    const handleAction = (row, type) => {
        openModal(type, row)
    }


    const modals = () => (
        <>
            <ModalUsunProfil
                show={modalState.delete}
                handleClose={() => closeModal('delete')}
                currPozycja={currPozycja}
            />

        </>
    )
    const th = () => {
        return (
            <>
                <th>Akcje</th>
            </>
        )
    }

    const td = (row) => {
        const allowItem = {
            show: {
                view: true,
                edit: canModifyProfile,
                delete: canModifyProfile,
                historia: true,
                klonuj: true,
            },
        }
        return (
            <>
                <td>
                    <div className={'d-flex gap-2'}>
                        {allowItem.show.view && (
                            <LinkContainer
                                to={`/${rola}/profile/podglad/${row.id}`}
                            >

                                <ButtonWithIcon
                                    onClick={() => handleAction(row, 'view')}
                                    // disabled={loading}
                                    size={'sm'}
                                    icon={<Icons.eye/>}
                                    variant={'secondary'}
                                    title='Podgląd profilu'
                                />
                            </LinkContainer>
                        )}

                        {allowItem.show.edit && (
                            <LinkContainer
                                to={`/${rola}/profile/edycja/${row.id}`}
                            >

                                <ButtonWithIcon
                                    onClick={() => handleAction(row, 'edit')}
                                    // disabled={loading}
                                    size={'sm'}
                                    icon={<Icons.edit/>}
                                    title='Edytuj profil'
                                />
                            </LinkContainer>
                        )}

                        {allowItem.show.delete && (
                            <ButtonWithIcon
                                onClick={() => handleAction(row, 'delete')}
                                variant={'danger'}
                                size={'sm'}
                                icon={<Icons.delete/>}
                                title='Usuń profil'
                            />
                        )}
                        {canViewUsers && (
                            <LinkContainer
                                to={`/${rola}/profile/konta/${row.id}`}
                            >
                                <ButtonWithIcon
                                    size={'sm'}
                                    variant={'info'}
                                    icon={<Icons.person/>}
                                    title='Lista kont powiązanych z profilem'
                                />
                            </LinkContainer>
                        )}
                    </div>
                </td>
            </>
        )
    }


    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}
            <HeaderTitle
                breadcrumbLinks={[{label: titleName}]}
                home
                nav
                destination={'/'}
                size={'fs-3'}
                title={titleName}
            />
            <div className={'d-flex justify-content-between align-items-center gap-3 flex-wrap'}>
                {canViewUsers && (
                    <LinkContainer
                        to={`/${rola}/profile/uzytkownicy/lista`}
                    >
                        <ButtonWithIcon
                            size={'lg'}
                            text={'Lista użytkowników'}
                            variant={'secondary'}
                            icon={<Icons.person/>}
                            title='Lista wszystkich użytkowników'
                        />
                    </LinkContainer>
                )}

                {canModifyProfile && (
                    <LinkContainer
                        to={`/${rola}/profile/edycja/nowy`}
                    >
                        <ButtonWithIcon
                            size={'lg'}
                            text={'Dodaj nowy profil'}
                            variant={'primary'}
                            icon={<Icons.add/>}
                            title='Dodaj nowy profil'
                        />
                    </LinkContainer>
                )}
            </div>
            <SimpleTable
                detailKey={'oper_profile'}
                columns={tableListaProfili}
                addTh={th}
                addTd={td}
                data={listaPozycji?.data}
            />
        </>
    )
}

ViewListaProfili.propTypes = {
    moje: PropTypes.bool,
}

export default ViewListaProfili
